export default {
    case_hospitalization_1: 'Hospitalized',
    case_hospitalization_2: 'Unhospitalized',
    case_hospitalization_100: 'NaN',
};
